import React, { useState } from 'react';
import '@styles/Features/formNormalizarDomicilio.scss';
import '../../Statics/Scss/Pages/ingresarDomicilio.scss';
import Label from '../../Components/Common/Formik/Label';
import InputFormik from '../../Components/Common/Formik/Input';
import SelectFormik from '../../Components/Common/Formik/Select';
import Link from '../../Components/Common/common/src/link/Link.jsx';
import { Form, Formik } from 'formik';
import { Button, LoginLayout } from '@lana-ui/login';
import DomicilioSchema from '../../Validations/ValidacionDomicilioCompleto';
import provinciasMap from '../../Models/Provincias';
import tipoDePropiedadMap from '../../Models/TipoDePropiedad';
import Divider from '../../Components/Common/common/src/divider/Divider.jsx';
import GetParamURL from '../../Helpers/GetParamURL';
import Modal from '../../Components/Common/common/src/modal/Modal.jsx';
import ModalBodyConfirmarDomicilio from '../../Components/Features/Domicilio/ModalBodyConfirmarDomicilio';
import { validaDomicilioExistente } from '../../Validations/ValidacionDomicilioExistente';
import domicilioToObjectMap from '../../Map/DomicilioToObjectMap';
import TextAreaFormik from '../../Components/Common/Formik/TextArea';


const CompletarDomicilio = ({
    tipoPropiedadSelected,
    seleccionCountry,
    domicilioElegido,
    setIsLastStep,
    setTipoPropiedadSelected,
    setSeleccion,
    send,
    state,
    errorNormalizacion,
    setErrorNormalizar,
    setToastDomicilioExistente,
}) => {
    const [observaciones, setObservaciones] = useState(null);
    const [seleccionTipoPropiedad, setSeleccionTipoPropiedad] = useState(tipoPropiedadSelected);
    const [openModal, setOpenModal] = useState(false);
    const planCampania = state.context?.planCampania;
    const urlParams = GetParamURL();
    const [nuevoDomicilio, setNuevoDomicilio] = useState();
    const [provinciaSeleccionada, setProvinciaSeleccionada] = useState(domicilioElegido?.provincia ? domicilioElegido.provincia : 'BUENOS AIRES');
    const domiciliosGuardados = state.context?.domicilio.map(domicilioToObjectMap);

    const handleSubmit = (domicilio) => {
        const modificoDomicilio = !errorNormalizacion ? checkModificacionDomicilio(domicilio) : false;
        const payload = {
            IdCanalVenta: parseInt(urlParams.canalDeVenta),
            PlanId: planCampania?.id,
            CorrelationId: state.context.dataVenta?.ventaResponse?.CorrelationId,
            EditarDomicilio: {
                addressId: state.context.dataVenta?.ventaResponse?.AddressId,
                altura: domicilio.numero ? domicilio.numero : null,
                calle: domicilio.calle ? domicilio.calle : null,
                cp: domicilio.cp ? domicilio.cp : null,
                dpto: domicilio.dto ? domicilio.dto : 'S/N',
                entreCalle1: domicilio.entreCalle1 ? (domicilio.entreCalle1 === '-' ? null : domicilio.entreCalle1.trimEnd()) : null,
                entreCalle2: domicilio.entreCalle2 ? (domicilio.entreCalle2 === '-' ? null : domicilio.entreCalle2.trimEnd()) : null,
                localidad: domicilio.localidad ? domicilio.localidad : null,
                pais: 'ARGENTINA',
                piso: domicilio.piso ? domicilio.piso : 'S/N',
                provincia: domicilio.provincia ? domicilio.provincia : provinciaSeleccionada,
                torre: domicilio.torre ? domicilio.torre : null,
                cuerpo: domicilio.cuerpo ? domicilio.cuerpo : null,
                lote: domicilio.lote ? domicilio.lote : null,
                observaciones: observaciones,
                tipoDePropiedad: seleccionTipoPropiedad.toUpperCase() === 'COUNTRY' ? 'COUNTRY-BARRIO-CLUB DE CAMPO' : seleccionTipoPropiedad.toUpperCase(),
                estaHabilitada: false,
                barrio: domicilio.barrio ? domicilio.barrio : null,
                nombreDePropiedad: domicilio.nombreComplejo ? domicilio.nombreComplejo : null,
                // normalizada: modificoDomicilio ? false : !errorNormalizacion,
                normalizada: true,
                omiteNormalizar: true
            },
        };
        const existeDomicilio = domiciliosGuardados.length < 1 ? false : validarDomicilioExistente(payload.EditarDomicilio);
        if (!existeDomicilio) {
            if (errorNormalizacion || modificoDomicilio) {
                setNuevoDomicilio(payload);
                setOpenModal(true);
                return;
            } else {
                send('SUBMIT', { dataDomicilio: payload });
            }
        } else {
            setIsLastStep(false);
            setToastDomicilioExistente(true);
        }
    };

    const checkModificacionDomicilio = (domicilio) => {
        return (domicilioElegido?.entreCalle1 != domicilio.entreCalle1 || domicilioElegido?.entreCalle2 != domicilio.entreCalle2 || domicilioElegido?.localidad != domicilio.localidad);
    };

    const validarDomicilioExistente = (values) => {
        const aux = domicilioToObjectMap(values);
        const existeDomicilio = validaDomicilioExistente(aux, domiciliosGuardados);
        return existeDomicilio;
    };

    const handleChange = (e) => {
        setSeleccionTipoPropiedad(e.target.value);
        setTipoPropiedadSelected(e.target.value);
        if (e.target.value === 'country' || seleccionTipoPropiedad === 'country') {
            setIsLastStep(false);
            setSeleccion(null);
        }
    };

    const handleConfirmarCambio = () => {
        send('SUBMIT', { dataDomicilio: nuevoDomicilio });
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const volverAtras = () => {
        setErrorNormalizar(false);
        setIsLastStep(false);
    };

    const handleProvincia = (e) => {
        setProvinciaSeleccionada(e.target.value);
    };

    return (
        <>
            <Formik
                initialValues={{
                    tipoDePropiedad: seleccionTipoPropiedad,
                    calle: domicilioElegido?.calle,
                    numero: domicilioElegido?.altura,
                    cp: domicilioElegido?.codigoPostal.replace(/\D/g, ''),
                    entreCalle1: seleccionCountry ? (seleccionCountry.entreCalle1 ? seleccionCountry.entreCalle1 : '-') : domicilioElegido?.entreCalle1 ? domicilioElegido?.entreCalle1 : '',
                    entreCalle2: seleccionCountry ? (seleccionCountry.entreCalle2 ? seleccionCountry.entreCalle2 : '-') : domicilioElegido?.entreCalle2 ? domicilioElegido?.entreCalle2 : '',
                    provincia: seleccionCountry ? seleccionCountry.Provincia : domicilioElegido?.provincia,
                    localidad: seleccionCountry ? seleccionCountry.Localidad : domicilioElegido?.localidad,
                    barrio: seleccionCountry ? seleccionCountry.Barrio : '',
                    observaciones: '',
                    torre: '',
                    escalera: '',
                    cuerpo: '',
                    piso: '',
                    dto: '',
                    nombreComplejo: '',
                    nombreCountry: seleccionCountry ? seleccionCountry.Barrio : '',
                }}
                enableReinitialize
                validationSchema={DomicilioSchema}
                onSubmit={handleSubmit}
            >
                {() => (
                    <Form className="domicilios">
                        {openModal && (
                            <Modal closeModal={handleCloseModal}>
                                <ModalBodyConfirmarDomicilio nuevoDomicilio={nuevoDomicilio} confirmarCambio={handleConfirmarCambio} modificarDomicilio={handleCloseModal} />
                            </Modal>
                        )}
                        <div className="--mb-24">
                            <Label text={'Tipo de propiedad'} />
                            <SelectFormik handleChange={(e) => handleChange(e)} name="tipoDePropiedad">
                                {tipoDePropiedadMap.map((tipoDePropiedad) => {
                                    return (
                                        <option value={tipoDePropiedad.id} key={tipoDePropiedad.id}>
                                            {tipoDePropiedad.descripcion}
                                        </option>
                                    );
                                })}
                            </SelectFormik>
                        </div>

                        {tipoPropiedadSelected === 'country' && (
                            <div className="--mb-24">
                                <Label text={'Nombre Country'} />
                                <InputFormik disabled={true} id="calle" type="text" name="nombreCountry" value={seleccionCountry?.Barrio} />
                                <Link size="5xs" onClick={() => setIsLastStep(false)}>
                                    No es mi country
                                </Link>
                            </div>
                        )}

                        <div className="--mb-24">
                            <Label text={'Domicilio'} />
                            <InputFormik disabled={!errorNormalizacion} id="calle" type="text" name="calle" placeholder="Ingresá la dirección" />
                        </div>
                        <div className="inputs --mb-24">
                            <div>
                                <Label text="Número" />
                                <InputFormik disabled={!errorNormalizacion} name="numero" type="text" />
                            </div>
                            <div className="--mt-24-mobile">
                                <Label text="Código postal" />
                                <InputFormik disabled={!errorNormalizacion} name="cp" type="text" />
                                <Link size="5xs" href="https://www.correoargentino.com.ar/formularios/cpa" target="_blank">
                                    No sé mi código postal
                                </Link>
                            </div>
                        </div>

                        <div className="inputs --mb-24">
                            <div>
                                <Label text="Entre calle" />
                                <InputFormik name="entreCalle1" type="text" disabled={seleccionTipoPropiedad === 'country'} />
                            </div>
                            <div className="--mt-24-mobile">
                                <Label text="Y calle" />
                                <InputFormik name="entreCalle2" type="text" disabled={seleccionTipoPropiedad === 'country'} />
                            </div>
                        </div>
                        <div className="inputs --mb-24">
                            <div>
                                <Label text="Provincia" />
                                <SelectFormik
                                    handleChange={handleProvincia}
                                    name="provincia"
                                    type="text"
                                    placeholder="[Provincia]"
                                    className="provincia"
                                    disabled={seleccionTipoPropiedad === 'country'}
                                >
                                    {provinciasMap &&
                                        provinciasMap.map((provincia) => {
                                            return (
                                                <option value={provincia.id} key={provincia.id}>
                                                    {provincia.descripcion}
                                                </option>
                                            );
                                        })}
                                </SelectFormik>
                            </div>
                            <div className="--mt-24-mobile">
                                <Label text="Localidad" />
                                <InputFormik name="localidad" type="text" disabled={seleccionTipoPropiedad === 'country'} />
                            </div>
                        </div>
                        <div className="--mb-24">
                            <Label text="Barrio" />
                            <InputFormik name="barrio" type="text" disabled={seleccionTipoPropiedad === 'country'} />
                        </div>

                        {seleccionTipoPropiedad !== 'country' && seleccionTipoPropiedad !== 'casa' && (
                            <>
                                <Divider />
                                {(seleccionTipoPropiedad === 'comercio' || seleccionTipoPropiedad === 'complejo') && (
                                    <div className="--mb-24">
                                        <Label text={'Nombre del complejo'} />
                                        <InputFormik name="nombreComplejo" type="text" />
                                    </div>
                                )}
                                <div className="inputs-three-columns">
                                    <div>
                                        <Label text={'Piso'} />
                                        <InputFormik name="piso" type="text" />
                                    </div>
                                    <div className="--mt-24-mobile">
                                        <Label text={'Dto'} />
                                        <InputFormik name="dto" type="text" />
                                    </div>
                                    <div className="--mt-24-mobile">
                                        <Label text={'Torre'} />
                                        <InputFormik name="torre" type="text" description={seleccionTipoPropiedad !== 'complejo' && 'Opcional'} />
                                    </div>
                                </div>

                                <div className="inputs --mb-24">
                                    <div className="--mt-24-mobile">
                                        <Label text={'Cuerpo'} />
                                        <InputFormik name="cuerpo" type="text" description={seleccionTipoPropiedad !== 'complejo' && 'Opcional'} />
                                    </div>
                                    <div className="--mt-24-mobile">
                                        <Label text={'Escalera'} />
                                        <InputFormik name="escalera" type="text" description={seleccionTipoPropiedad !== 'complejo' && 'Opcional'} />
                                    </div>
                                </div>
                            </>
                        )}

                        <div className='--mb-24'>
                            <Label text="Observaciones" />
                            <TextAreaFormik maxlength="100" className="" onBlur={(e) => setObservaciones(e.target.value)} name="observaciones" />
                            <span className="com-textarea__descrip --fivexs">
                                La observación no puede tener más de 100 caracteres
                            </span>
                        </div>

                        <Button data-dd-action-name="Guarda datos domicilio" type="submit" label={'FINALIZAR'} className="--not-disabled --mr-16" />
                        <Button tag="input" label="VOLVER A VALIDAR DOMICILIO" className="--border-blue" onClick={volverAtras} />
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default CompletarDomicilio;
